import axios from 'axios'
import {share} from '../vue.config'
import qs from 'qs'
export function getShareList() {
  return axios.get(share + '/public/share/getClassList');
}
export function postMsg(data) {
  return axios.post(share + '/public/share/addData',qs.stringify(data));
}
export function getCpk() {
  return share+'/getCaptcha';
}
export function getShareAll() {
  return axios.get(share + '/public/share/getDataList?search=&offset=0&limit=2000&_=1617609909046');
}



// WEBPACK FOOTER //
// ./src/services/shareService.js